export const TAX_BUCKET_BALANCE = {
  HEADER: 'TAX_BUCKET_BALANCE_HEADER',
};

export const AUTO_SAVING_TEXTS = {
  HEADER: 'AUTO_SAVING_COMPONENT_HEADER',
  MAIN_TEXT: 'TAX_BUCKET_AUTO_SAVING_TEXT',
  BUTTON_TEXT: 'TAX_BUCKET_BUTTON_TEXT',
  DISCLAIMER: 'TAX_BUCKET_DISCLAIMER',
} as const;

export const INPUT_MONEY_CSS =
  'border rounded-md focus:outline-none w-[17.5rem] h-[4rem] text-center font-metricMedium text-2xl';

export const TAX_BUCKET_PERSONALIZATION = {
  DEFAULT_ESTIMATED_PERCENT: 20,
  MAX_RECOMMENDED_PERCENT: 0.4,
  MIN_RECOMMENDED_PERCENT: 0.05,
  MAX_PERCENTAGE_INPUT_VALUE: 40,
  INPUT_STEP_IN_PX: 7.6,
  RECOMMENDATION_STEP_IN_PX: 7.4,
  INITIAL_PERCENTAGE: 5,
  INITIAL_MARGIN_ESTIMATED_PERCENTAGE: 6,
  INITIAL_STATE_OBJECT: {
    currentStep: 1,
    hasUserOtherSources: null,
    annualIncome: 0,
    annualExpense: 0,
    annualSalary: 0,
    savePercent: 0,
    currentStepNumber: 1,
    isBusinessValid: false,
  },
  STEPS: {
    STEP_1: 1,
    STEP_2: 2,
    STEP_2_OTHER: 3,
    STEP_3: 4,
    STEP_4: 5,
    STEP_CONFIRMATION: 6,
  },
  HEADER: {
    STEP_1: 'TAX_BUCKET_PERSONALIZATION_HEADER_STEP_1',

    STEP_2_1: 'TAX_BUCKET_PERSONALIZATION_HEADER_STEP_2_1',
    STEP_2_2: 'TAX_BUCKET_PERSONALIZATION_HEADER_STEP_2_2',
    STEP_2_3: 'TAX_BUCKET_PERSONALIZATION_HEADER_STEP_2_3',
    STEP_2_GREEN_WORD: 'TAX_BUCKET_PERSONALIZATION_HEADER_STEP_2_GREEN_WORD',

    STEP_2_OTHER_1: 'TAX_BUCKET_PERSONALIZATION_HEADER_STEP_2_OTHER_1',
    STEP_2_OTHER_2: 'TAX_BUCKET_PERSONALIZATION_HEADER_STEP_2_OTHER_2',
    STEP_2_OTHER_3: 'TAX_BUCKET_PERSONALIZATION_HEADER_STEP_2_OTHER_3',

    STEP_3_1: 'TAX_BUCKET_PERSONALIZATION_HEADER_STEP_3_1',
    STEP_3_2: '?',
    STEP_3_GREEN_WORD: 'TAX_BUCKET_PERSONALIZATION_HEADER_STEP_3_GREEN_WORD',

    STEP_4: 'TAX_BUCKET_PERSONALIZATION_HEADER_STEP_4',
    STEP_CONFIRMATION: 'TAX_BUCKET_PERSONALIZATION_HEADER_STEP_CONFIRMATION',
  },
  TEXT: {
    STEP_1: 'TAX_BUCKET_PERSONALIZATION_TEXT_STEP_1',
    STEP_2: 'TAX_BUCKET_PERSONALIZATION_TEXT_STEP_2',
    STEP_2_OTHER: 'TAX_BUCKET_PERSONALIZATION_TEXT_STEP_2_OTHER',
    STEP_3: 'TAX_BUCKET_PERSONALIZATION_TEXT_STEP_3',
    STEP_4_1: 'TAX_BUCKET_PERSONALIZATION_TEXT_STEP_4_1',
    STEP_4_2: 'TAX_BUCKET_PERSONALIZATION_TEXT_STEP_4_2',
    STEP_CONFIRMATION: 'TAX_BUCKET_PERSONALIZATION_TEXT_STEP_CONFIRMATION',
  },
  BUTTON_TITLES: {
    YES_BTN: 'TAX_BUCKET_PERSONALIZATION_YES_BUTTON',
    NO_BTN: 'TAX_BUCKET_PERSONALIZATION_NO_BUTTON',
    CONTINUE_BTN: 'TAX_BUCKET_PERSONALIZATION_CONTINUE_BUTTON_TEXT',
    SET_BTN: 'TAX_BUCKET_PERSONALIZATION_SET_BUTTON_TEXT',
    CONFIRM_BTN: 'TAX_BUCKET_PERSONALIZATION_CONFIRM_BUTTON_TEXT',
    SET_PERCENTAGE_MANUALLY: 'TAX_BUCKET_PERSONALIZATION_SET_MANUALLY_BUTTON',
  },
} as const;

export const MONEY_MOVE = {
  HEADER: {
    ADD: 'TAX_BUCKET_ADD_HEADER',
    WITHDRAW: 'TAX_BUCKET_WITHDRAW_HEADER',
  },
  TEXT: {
    ADD: 'TAX_BUCKET_ADD_TEXT',
    WITHDRAW: 'TAX_BUCKET_WITHDRAW_TEXT',
  },
  BUTTON_TEXT: {
    ADD: 'TAX_BUCKET_ADD_BUTTON_TEXT',
    WITHDRAW: 'TAX_BUCKET_WITHDRAW_BUTTON_TEXT',
  },
  ERROR_MESSAGE: {
    ADD: 'TAX_BUCKET_ADD_ERROR_MESSAGE',
    WITHDRAW: 'TAX_BUCKET_WITHDRAW_ERROR_MESSAGE',
  },
  PROCESSING: 'BUTTON_LOADER_TEXT',
} as const;

export const SUB_PATHS = {
  ADD_PATH: ':false',
  WITHDRAW_PATH: ':true',
  TAX_BUCKET_ACTIVATED: ':isSavingsActivated',
};

export const TAX_BUCKET_DASHBOARD = {
  PAGE_HEADER: 'TAX_BUCKET_PAGE_HEADER',
  POPUP_SUCCESS: {
    ADD: 'TAX_BUCKET_ADD_SUCCESS_POPUP_MESSAGE',
    WITHDRAW: 'TAX_BUCKET_WITHDRAW_SUCCESS_POPUP_MESSAGE',
    CHANGED: 'TAX_BUCKET_ACTIVATED_SUCCESSFULLY_POPUP_MESSAGE_FIRST_TIME',
    ACTIVATED_1: 'TAX_BUCKET_ACTIVATED_SUCCESSFULLY_POPUP_MESSAGE_1',
    ACTIVATED_2: 'TAX_BUCKET_ACTIVATED_SUCCESSFULLY_POPUP_MESSAGE_2',
  },
} as const;

export const TAX_BUCKET_ADD = {
  PAGE_HEADER: 'TAX_BUCKET_ADD_PAGE_HEADER',
} as const;

export const TAX_BUCKET_WITHDRAW = {
  PAGE_HEADER: 'TAX_BUCKET_WITHDRAW_PAGE_HEADER',
} as const;

export const TAX_BUCKET_PERSONALIZATION_PAGE_HEADER = 'TAX_BUCKET_PERSONALIZATION_PAGE_HEADER';

export const BUSINESS_TYPE = {
  LLC: 'LLC',
  DBA: 'DBA',
} as const;
